import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Table } from 'reactstrap';
import { useIntl } from 'react-intl';

import withDragAndDropContext from '../../../helpers/withDragAndDropContext';

import AdminMetadataGroupListHeader from '../MetadataGroupListHeader';
import AdminCustomFieldsListHeader from './ListHeader';
import AdminCustomFieldsListItem from './ListItem';

const AdminCustomFieldsList = ({
  metadataGroup,
  customFields,
  deleteCustomFieldFromList,
  moveCustomField,
  saveCustomFields,
}) => {
  const [dragging, setDragging] = useState(false);
  const [collapseOpen, setCollapseOpen] = useState(true);

  const intl = useIntl();

  return (
    <div className="table-wrapper">
      <Table className="users-list custom-fields-list" responsive>
        {metadataGroup && (
          <thead className={classnames('master-header', { 'master-header-content-collapsed': !collapseOpen })}>
            <AdminMetadataGroupListHeader
              metadataGroup={metadataGroup}
              collapseOpen={collapseOpen}
              handleCollapseOpen={setCollapseOpen}
              scope="custom-fields"
            />
          </thead>
        )}
        {collapseOpen && (
          <>
            <thead>
              <AdminCustomFieldsListHeader />
            </thead>
            <tbody className={classnames({ dragging })}>
              {customFields.map(customField => (
                <AdminCustomFieldsListItem
                  key={customField.id}
                  index={customField.id}
                  customField={customField}
                  deleteCustomFieldFromList={deleteCustomFieldFromList}
                  canDrag={true}
                  setDragging={setDragging}
                  moveCustomField={moveCustomField}
                  saveCustomFields={saveCustomFields}
                />
              ))}
              {(metadataGroup && customFields.length === 0) && (
              <tr>
                <th scope="row" colSpan={6} className="nothing-found-table">
                  {intl.formatMessage({ defaultMessage: 'No Custom Fields assigned to this Group' })}
                </th>
              </tr>
              )}
            </tbody>
          </>
        )}
      </Table>
    </div>
  );
};

AdminCustomFieldsList.propTypes = {
  metadataGroup: PropTypes.object,
  customFields: PropTypes.array.isRequired,
  deleteCustomFieldFromList: PropTypes.func.isRequired,
  moveCustomField: PropTypes.func.isRequired,
  saveCustomFields: PropTypes.func.isRequired,
};

AdminCustomFieldsList.defaultProps = {
  metadataGroup: null,
};

export default withDragAndDropContext(AdminCustomFieldsList);
